// extracted by mini-css-extract-plugin
export default {"header":"factSheetReport_header__VddP5","headerTitle":"factSheetReport_headerTitle__sXeiT","content":"factSheetReport_content__3RoZF","divider":"factSheetReport_divider__+UvJz"};